/** Used for short, important text or numerals, like brand content. */
export const display = 'var(--cb-font-display)';

/** Used for page headings, like profile or settings. */
export const largeTitle = 'var(--cb-font-large-title)';

/** Used for page headings, like profile or settings. */
export const title = 'var(--cb-font-title)';

/** Used to introduce new sections or in large components, like modals. */
export const headline = 'var(--cb-font-headline)';

/** Used to introduce subsections or in small components like banners. */
export const subheadline = 'var(--cb-font-subheadline)';

/** Default size for reading text. */
export const body = 'var(--cb-font-body)';

/** Used to style field labels or to emphasize text. It pairs with Body. */
export const bodyLabel = 'var(--cb-font-body-label)';

/** Used to style interactive elements, like buttons and chips. */
export const bodyMedium = 'var(--cb-font-body-medium)';

/** Used for short paragraph or helper text, like captions or metadata. */
export const caption = 'var(--cb-font-caption)';

/** Used to style field labels or to emphasize text. It pairs with Caption. */
export const captionLabel = 'var(--cb-font-caption-label)';

/** Used to style interactive elements, like buttons and chips. */
export const captionMedium = 'var(--cb-font-caption-medium)';

/** Used for helper text or legal copy, like text that appears below an input field. */
export const footnote = 'var(--cb-font-footnote)';

/** Used to style field labels or to emphasize text. It pairs with Footnote. */
export const footnoteLabel = 'var(--cb-font-footnote-label)';

/** Used to style interactive elements, like badges. */
export const footnoteMedium = 'var(--cb-font-footnote-medium)';
